(function () {
  'use strict';

  angular
    .module('app')
    .component('productCategoryAssociatedTaxes', productCategoryAssociatedTaxes());

  function productCategoryAssociatedTaxes() {
    return {
      bindings: {
        productCategory: '<',
        taxes: '<',
        productCategoryIsExempt: '<',
        onAssociatedTaxesSaved: '&',
        onAssociatedTaxesCanceled: '&',
      },
      controller: ProductCategoryAssociatedTaxesComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/product-categories/components/' +
        'product-category-associated-taxes/product-category-associated-taxes.component.html',
    };
  }

  ProductCategoryAssociatedTaxesComponent.$inject = [
    'UtilService',
    'ModalWindowConfirmService',
    'SessionService',
    '$location',
    'ProductCategoryService',
    'ProductService',
  ];

  function ProductCategoryAssociatedTaxesComponent(
    UtilService,
    ModalWindowConfirmService,
    SessionService,
    $location,
    ProductCategoryService,
    ProductService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // vm.$onInit = function() {
    vm.$onChanges = function () {
      // !important to update sale exoneration
      vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

      setProductCategoryAsociatedTaxesExoneration(vm.taxes);

      // Initializers
      vm.validateAssociatedTaxesApplied();
    };

    // public methods
    // -----------------------
    // Validate that at least on tax is selected for both scope types - NOT required for now
    vm.validateAssociatedTaxesApplied = function () {
      vm.invalidAssociatedTaxes = false;
      // vm.invalidAssociatedTaxes = TaxService.validateAssociatedTaxesApplied(vm.taxes);
    };

    vm.applyAssociatedTaxes = function () {
      if (vm.invalidAssociatedTaxes) return;

      let confirmAssociatedTaxes = function () {
        let productCategory = setProductCategory();

        // console.log(productCategory);
        // return;

        vm.sendingAssociatedTaxes = true;
        ProductCategoryService.applyAssociatedTaxes(productCategory, true).then(function (
          response
        ) {
          if (response) {
            // Success
            vm.onAssociatedTaxesSaved({ productCategory: response });
          }

          vm.sendingAssociatedTaxes = false;
        });
      };

      let params = {
        title: 'APPLY_CHANGES',
        body: 'APPLY_PRODUCT_CATEGORY_ASSOCIATED_TAXES_WARNING',
        mode: 'danger',
        requireConfirmation: true,
      };

      if (vm.productCategoryIsExempt) {
        params.body = 'MARK_AS_EXEMPT_PRODUCT_CATEGORY_MSG';
      }

      ModalWindowConfirmService.open(params, confirmAssociatedTaxes);
    };

    vm.cancelApplyAssociatedTaxes = function () {
      vm.validateAssociatedTaxesApplied();

      vm.onAssociatedTaxesCanceled();
    };

    vm.close = function () {
      // This is a hack. If we use location in a modal, it closes the modal but remove the scrollbar completely
      setTimeout(() => {
        $location.path('/taxes');
      }, 500);
    };

    vm.openProductTaxExoneration = function (tax, mode) {
      // exoneration
      const successCallback = function (exonerationObj) {
        tax.exoneration = exonerationObj;

        if (mode === 'create') {
          let productCategory = setProductCategory();

          ProductCategoryService.applyAssociatedTaxes(productCategory).then(function (response) {
            vm.onAssociatedTaxesSaved({ productCategory: response });
          });
        }
      };

      if (!tax.exoneration) {
        tax.exoneration = {};
      }

      ProductService.openProductTaxExoneration(
        tax.exoneration,
        tax,
        'product_category',
        vm.productCategory.id,
        mode,
        successCallback
      ); // 'ProductCategory'
    };

    vm.changeProductTaxExonerationStatus = function (tax) {
      ProductService.changeProductTaxExonerationStatus(tax.exoneration, 'product_category'); // , vm.productCategory.id
    };

    vm.deleteProductTaxExoneration = function (tax) {
      let successCallback = function () {
        tax.exoneration = null;
      };

      ProductService.deleteProductTaxExoneration(
        tax.exoneration,
        'product_category',
        successCallback
      ); // , vm.productCategory.id
    };

    // private methods
    // -----------------------
    function setProductCategory() {
      let associatedTaxIds = [];

      if (!vm.productCategoryIsExempt) {
        let associatedPurchaseTaxIds = vm.taxes.purchases
          .filter((purchaseTax) => purchaseTax.checked)
          .map((purchaseTax) => purchaseTax.id);

        let associatedSaleTaxIds = vm.taxes.sales
          .filter((saleTax) => saleTax.checked)
          .map((saleTax) => saleTax.id);

        associatedTaxIds = associatedPurchaseTaxIds.concat(associatedSaleTaxIds);
      }

      return {
        id: vm.productCategory.id,
        associated_tax_ids: associatedTaxIds,
        is_exempt: vm.productCategoryIsExempt,
      };
    }

    // Include the exoneration for the tax
    function setProductCategoryAsociatedTaxesExoneration(taxes) {
      taxes.purchases.map((tax) => {
        tax.exoneration = vm.productCategory.exonerations.find(
          (exoneration) => exoneration.tax_id === tax.id
        );
      });

      taxes.sales.map((tax) => {
        tax.exoneration = vm.productCategory.exonerations.find(
          (exoneration) => exoneration.tax_id === tax.id
        );
      });
    }
  }
})();
